export const enGBMessages = {
  global: {
    build: "Build",
    buildCosts: "Build costs",
    creatingAppraisal: "Creating new appraisal in your project.",
    equityIrr: "Equity IRR",
    finance: "Finance",
    gdv: "GDV",
    gia: "GIA",
    grossDevelopmentValue: "Gross development value",
    landTax: "Stamp duty land tax",
    landTaxShort: "Stamp duty",
    loadingAppraisal: "Loading your appraisal.",
    loadingPublicProjectTemplate: "Loading the template.",
    logoAlt: "Aprao, real estate appraisal software",
    netDevelopmentValue: "Net development value",
    netRevenue: "Net revenue",
    nia: "NIA",
    ofBuildCosts: "of build costs",
    ofGdv: "of GDV",
    other: "Other Costs",
    otherCosts: "Other costs",
    percentBuild: "% build",
    percentGdv: "% GDV",
    projectIrr: "Project IRR",
    roGdv: "RoGDV",
    roc: "RoC",
    totalBuildCosts: "Total build costs",
    totalOtherCosts: "Total other costs",
  },
  project: {
    appraisals: "Appraisals",
    createNewAppraisal: "Create new appraisal",
    noAppraisals: "You have not added any appraisals yet.",
    deleteAppraisalWarning:
      'The appraisal "{title}" will be removed with no way to get it back.',
    shareAppraisal: "Share appraisal",
    compareAppraisal: "Compare appraisals",
  },
  revenue: {
    yield: "Yield",
    agentFees: "Agent fees",
  },
  build: {
    grossGia: "Gross (GIA)",
    perGia: "per {unit}² (GIA)",
    ofNia: "of NIA",
    totalBuildCostsExcludingContingency:
      "Total build costs excluding contingency",
    totalBuildCostsIncludingContingency:
      "Total build costs including contingency",
  },
  purchase: {
    customLandTax: "Custom stamp duty",
    effectiveLandTaxRate: "Effective stamp duty rate",
  },
  finance: {
    forwardFundedBuildCosts: "Forward funded build costs",
    forwardFundedGdv: "Forward funded GDV",
    mainBuildCosts: "Main build costs",
  },
  metrics: {
    summaryAppraisal: "Summary Appraisal",
    projectIrr: "Project IRR",
    equityIrr: "Equity IRR",
  },
  report: {
    developmentAppraisal: "Development Appraisal",
    footer: "Appraisal by Aprao.com - Development appraisals reimagined",
    summaryFinancialAppraisal: "Summary Financial Appraisal",
    mapError: "Sorry, we could not generate a map for this appraisal's address",
    sharedAppBarMessage: "This appraisal report has been shared with you.",
  },
  sensitivity: {
    buildCostsLabel: "Build costs",
    buildCostsUnit: "avg. per {unit}² GIA",
    gdvLabel: "GDV",
    profitCaption: "Profit sensitivity",
    rentLabel: "Rent",
    rentUnit: "avg. per {unit}²/{periodLabel}",
    residualCaption: "Residual value alongside profit sensitivity",
    rocCaption: "Return on cost sensitivity",
    yieldLabel: "Yield",
  },
  dynamicSensitivity: {
    roc: "Return on cost",
    profit: "Profit",
    residual: "Residual value",
  },
  errorHeadings: {
    appraisalCopy: "Sorry, we couldn't copy your appraisal.",
    appraisalCreate: "Sorry, we couldn't create your appraisal.",
    appraisalDelete: "Sorry, we couldn't delete your appraisal.",
    appraisalLoad: "Sorry, we couldn't load the appraisal.",
    appraisalReportGenerate: "Sorry, we couldn't generate your report.",
    appraisalSave: "Sorry, we couldn't save your appraisal.",
    appraisalShare: "Sorry, an error occurred while turning on sharing.",
    appraisalSharingLoad: "Sorry, we couldn't load the appraisal.",
    boardChange: "Sorry, we couldn't update your board.",
    boardCreate: "Sorry, we couldn't create a new board.",
    boardDelete: "Sorry, we couldn't delete the board.",
    boardListAppend: "Sorry, we couldn't add a new list.",
    boardListChange: "Sorry, we couldn't save your changes.",
    boardListDelete: "Sorry, we couldn't delete your list.",
    boardLoad: "Sorry, we couldn't load the board.",
    boardsHomeLoad: "Sorry, we couldn't load the home page.",
    cashflowDownload: "Sorry, we couldn't download your cash flow report.",
    global: "Sorry, we encountered a problem.",
    globalRefresh:
      "Sorry, we encountered a problem while loading the data from the server.",
    projectArchive: "Sorry, we couldn't archive your project.",
    projectArchivesLoad: "Sorry, we couldn't load your archived project.",
    projectCreate: "Sorry, we couldn't create your project.",
    projectCreateFromPublicTemplate:
      "Sorry, we couldn't create a new project from the template.",
    projectCreateFromSharingLink:
      "Sorry, we couldn't copy the shared appraisal.",
    projectCreateFromTemplate:
      "Sorry, we couldn't create a new project from your template.",
    projectDelete: "Sorry, we couldn't delete your project.",
    projectMakeTemplate:
      "Sorry, we couldn't make a template from your project.",
    projectMove: "Sorry, we couldn't save your changes.",
    projectPublicTemplateLoad: "Sorry, we couldn't load the project template.",
    projectSave: "Sorry, we couldn't save your project.",
    projectSend: "Sorry, we couldn't save your changes.",
    projectTemplateToggleVisibility:
      "Sorry, we couldn't change the visibility of your project template.",
    projectTemplatesLoad: "Sorry, we couldn't load your project templates.",
    projectUnarchive: "Sorry, we couldn't unarchive your project.",
  },
} as const;
